export const baseInfoConfig = [
  { label: '系统硬件', prop: 'hwVer' },
  { label: '系统软件', prop: 'swVer' },
  { label: '序列号', prop: 'sn' },
  { label: 'IP地址', prop: 'ipAddr' },
  {
    label: '当前场景',
    prop: 'sceneType',
    list: ['工作场景', '公共场景'],
    format(v) {
      return this.list[v] || '--';
    }
  },
  { label: '传感器数量', prop: 'sensorCount' }
];

/**
 * 设备基础信息 数据处理
 * @param {data: {}} res
 * @returns {{ name: string, value: string }[]}
 */
export function baseInfoHandler(res) {
  if (!res || !res.data) return [];
  let v = null;
  return baseInfoConfig.map(e => {
    if (typeof e.format === 'function') {
      v = e.format(res.data[e.prop]);
    } else {
      v = res.data[e.prop];
    }
    return { name: e.label, value: v || '--' };
  });
}

export function thresholdHandler({ ST, TW, H, L, M }) {
  return [H, L, ST, TW, M].join('/');
}

/**
 * tic传感器信息处理
 */
export function ticInfoHandler(res) {
  if (!res || !res.data || !res.data.tvocSensors) return;
  const tics = res.data.tvocSensors;
  const validThreshold = v => ({ H: v.H, L: v.L, ST: v.ST, TW: v.TW, M: v.M });
  return tics.map(e => ({
    sensorSeq: e.sensorSeq,
    code: e.code,
    sensorName: e.name,
    version: e.version,
    fullScale: e.fullScall,
    unit: e.unit,
    sensorSn: e.sensorSn,
    currentThreshold: validThreshold(e.currentParam || {}),
    commonThreshold: validThreshold(e.default2Param || {}),
    workThreshold: validThreshold(e.default1Param || {})
  }));
}

/**
 * cwa传感器信息处理
 */
export function cwaInfoHandler(res) {
  if (!res || !res.data || !res.data.cwaSensors) return;
  const cwa = res.data.cwaSensors;
  const validThreshold = v => (v && v.H) || '';
  return cwa.map(e => ({
    sensorSeq: e.sensorSeq,
    code: e.code,
    sensorName: e.name,
    version: e.version,
    unit: e.unit,
    fullScale: e.fullScall,
    sensorSn: e.sensorSn,
    currentThreshold: validThreshold(e.currentParam),
    commonThreshold: validThreshold(e.default2Param),
    workThreshold: validThreshold(e.default1Param)
  }));
}

/**
 * 更新连接状态信息
 * @param {{mods: {sysMod: any}}} res
 * @returns {{name:string, value: string}[]}
 */
export function statusInfoHandler(res) {
  if (!res || !res.mods || !res.mods.sysMod) return;
  const sysMod = res.mods.sysMod;
  const pumpStatus = ['停止', '开启', '故障'][sysMod.pumpRunstate];
  const mobileStatus = sysMod.mobileEnableState
    ? `已连接, 信号强度${sysMod.mobileSignalStrength}`
    : '未连接';
  const freeMem = sysMod.freeMemSize;
  const totalMem = sysMod.totalMemSize;
  return [
    { name: '气泵状态', value: pumpStatus },
    { name: '4G状态', value: mobileStatus },
    { name: '电池状态', value: `剩余${sysMod.batteryCapacity}%` },
    { name: '内存状态', value: `共${totalMem}M,剩余${freeMem}M` }
  ];
}

/**
 * 创建阈值子表头
 * @returns {{label: string, prop: string}[]}
 */
export function makeThresholdCols() {
  return [
    { label: 'H', prop: 'H', editable: true },
    { label: 'L', prop: 'L', editable: true },
    { label: 'STEL', prop: 'ST', editable: true },
    { label: 'TWA', prop: 'TW', editable: true },
    { label: 'MAC', prop: 'M', editable: true }
  ];
}

export const scheduler = {
  temp: null,
  tasks: {},
  add(id, fn) {
    this.tasks[id] = fn;
  },
  destroy() {
    this.tasks = {};
    document.addEventListener('click', this.temp);
  },
  exec(id) {
    const keys = Object.keys(this.tasks).filter(k => k !== id);
    keys.forEach(key => {
      if (typeof this.tasks[key] !== 'function') return;
      this.tasks[key]();
      delete this.tasks[key];
    });
  }
};
scheduler.temp = scheduler.exec.bind(scheduler);
document.addEventListener('click', scheduler.temp);

export const units = ['PPM', 'vol%', 'LEL%', 'mg/m³', 'PPB'];

function validData(data) {
  const params = [data.currentParam, data.default1Param, data.default2Param];
  return !params.some(data =>
    Object.keys(data || {}).some(e => {
      return !(data[e] === '' ? false : data[e] >= 0);
    })
  );
}

/**
 * 阈值设置接口
 * @param {'ticInfo'|'cwaInfo'} tab 标签页值
 * @returns 处理好的数据
 */
export function makeParams(tab, ctx) {
  const data = {};
  if (tab === 'ticInfo') {
    data.sensorType = 1;
    data.sensors = ctx[tab].data
      .map(e => ({
        sensorSeq: e.sensorSeq,
        code: e.code,
        unit: e.unit,
        currentParam: e.currentThreshold,
        default1Param: e.workThreshold,
        default2Param: e.commonThreshold
      }))
      .filter(e => validData(e));
  } else if (tab === 'cwaInfo') {
    data.sensorType = 2;
    data.sensors = ctx[tab].data
      .map(e => ({
        sensorSeq: e.sensorSeq,
        code: e.code,
        unit: e.unit,
        currentParam: { H: e.currentThreshold },
        default1Param: { H: e.workThreshold },
        default2Param: { H: e.commonThreshold }
      }))
      .filter(e => validData(e));
  }
  return data;
}
